import { render, staticRenderFns } from "./HolidayDel.vue?vue&type=template&id=798d00ab&lang=pug&"
import script from "./HolidayDel.vue?vue&type=script&lang=js&"
export * from "./HolidayDel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports